export const ADD_TOP_COMMENT_REQUEST = 'post/ADD_TOP_COMMENT_REQUEST';
export const ADD_TOP_COMMENT_SUCCESS = 'post/ADD_TOP_COMMENT_SUCCESS';
export const ADD_TOP_COMMENT_FAILURE = 'post/ADD_TOP_COMMENT_FAILURE';

export function addTopComment(postId, commentId) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: ADD_TOP_COMMENT_REQUEST,
    });

    const promise = request.post(`/_api/posts/${postId}/top-comment`, { commentId });

    return promise
      .then(post =>
        dispatch({
          type: ADD_TOP_COMMENT_SUCCESS,
          payload: post,
        })
      )
      .catch(() =>
        dispatch({
          type: ADD_TOP_COMMENT_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/add-top-comment.js